import React, { Suspense, FC } from 'react'

import { UpsellContent } from './UpsellContent'
import { UpsellContentFetching } from './UpsellContentFetching'

const Upsell: FC<{ applicationId: string }> = ({ applicationId }) => (
  <Suspense fallback={<UpsellContentFetching />}>
    <UpsellContent applicationId={applicationId} />
  </Suspense>
)

export { Upsell }
